import styled from 'styled-components';

export const Content = styled.div`
  padding: 24px 24px 0 24px;
  min-height: 320px;
  max-height: 450px;
  display: flex;
  flex-direction: column;
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;

  > div:nth-child(2) {
    ${({ theme }) => `
        color: ${theme.colors.primary[100]};
    `}
  }
`;

export const Chip = styled.div`
  padding: 12px 10px 12px 20px;
  width: 385px;
  min-width: 385px;
  display: flex;
  justify-content: space-between;
  background-color: white;
  border-radius: 12px;
  max-height: 60px;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.15);
`;

export const ChipContent = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Roboto;
  font-size: 16px;
`;

export const ChipName = styled.div``;

export const ChipEmail = styled.div`
  color: #1a6faa;
  position: relative;
  display: flex;

  > svg {
    position: absolute;
    bottom: -1px;
    right: -30px;
  }
`;

export const EmailSent = styled.div`
  display: flex;
  align-items: center;
  color: rgb(5, 198, 172);
  position: relative;
  bottom: 3px;
  left: 8px;
  gap: 1px;

  > svg {
    width: 22px;
  }
`;

export const EmailSentLabel = styled.div`
  display: flex;
  font-weight: 500;
  height: 17px;
`;

export const DeleteItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;

  svg {
    position: absolute;
    top: -6px;
    right: -3px;
    width: 20px;
  }
`;

export const Recipients = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  margin: 36px 0 0 0;
  flex-wrap: wrap;
  overflow: auto;
  flex: 1;
  padding-right: 12px;
  gap: 18px;
  padding-bottom: 24px;
`;

export const FooterOption = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
`;
